import { useEffect } from 'react';

import { useRecoilState } from 'recoil';

import { shouldDisplaySquareAd } from '~/atoms/googleAds';

const ModuleSquareAd: React.FC = () => {
  const [isDisplayable, setIsDisplayable] = useRecoilState(shouldDisplaySquareAd);

  useEffect(() => {
    if (!isDisplayable) {
      setIsDisplayable(true);
    }
  });

  return <></>;
};

export default ModuleSquareAd;
